// extracted by mini-css-extract-plugin
export default {"BaseCell":"sub-issues-progress-renderer-module__BaseCell--tfyPe","ButtonBase":"sub-issues-progress-renderer-module__ButtonBase--JNp5E"};